import ApiClient, {requestRemoteData} from '../../API/api';
import {toLocalDateString} from '../../common/utils/date.utils';

const GET_INVOICES = 'invoices';
const GET_FILTERED_INVOICES = 'invoices/all/filter';
const GET_PDF_INVOICE = 'invoices/:invoiceId/download'
const GET_BULK_PDF_INVOICES = 'invoices/bulk/download'

/**
 * @returns {Promise<RemoteData<Invoice>>}
 */
export const fetchInvoices = () => {
  return requestRemoteData(GET_INVOICES);
};

/**
 * En modo comercial suplantando, la cabecera hace que las facturas sean las del cliente
 * que se esta mirando (mismo criterio que el historial de pedidos).
 * @param {DateRange} dateRange - format YYYY-MM-DD
 * @param {string|null} actingAsNumCliente
 * @returns {Promise<RemoteData<Invoice[]>>}
 */
export const fetchInvoicesInDueDateRange = (dateRange, actingAsNumCliente = null) => {
  const headers = {};
  if (actingAsNumCliente) headers['X-Acting-As-Client'] = actingAsNumCliente;
  return requestRemoteData(
    GET_FILTERED_INVOICES,
    {
      headers,
      queryParams: {
        fromDueDate: toLocalDateString(dateRange.from),
        toDueDate: toLocalDateString(dateRange.to)
      }
    });
};

/**
 * @param {string} invoiceId
 * @return Promise<Blob>
 */
export const fetchPdfInvoice = (invoiceId) => {
  return ApiClient.performRequest(
    GET_PDF_INVOICE,
    {
      pathParams: { invoiceId },
      headers: { 'accept': 'application/pdf', 'Content-Type': 'application/pdf' }
    });
}

/**
 * @param {string[]} invoiceIds
 * @return Promise<RemoteData<Blob>>
 */
export const fetchBulkPdfInvoices = (invoiceIds) => {
  return requestRemoteData(
    GET_BULK_PDF_INVOICES,
    {
      method: 'POST',
      headers: { 'accept': 'application/octet-stream' },
      body: invoiceIds
    });
}
